(() => {
  const content = document.querySelector('.bo-editorial .article-template__content');
  if (!content || content.dataset.editorialReady) return;
  content.dataset.editorialReady = 'true';
  const headings = [...content.querySelectorAll('h2,h3')];
  if (headings.length > 2) {
    const existing = content.querySelector('nav[aria-label="Article contents"]');
    const details = document.createElement('details');
    details.className = 'bo-toc';
    const summary = document.createElement('summary');
    summary.textContent = 'In this article';
    details.append(summary);
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Article contents');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `bo-section-${index + 1}`;
        while (document.getElementById(id)) id += '-next';
        heading.id = id;
      }
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      link.dataset.level = heading.tagName.slice(1);
      nav.append(link);
    });
    details.append(nav);
    if (existing) existing.replaceWith(details);
    else headings[0].before(details);
  }
  content.querySelectorAll('table').forEach(table => {
    const wrapper = document.createElement('div');
    wrapper.className = 'bo-table-scroll';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Scrollable article table');
    table.before(wrapper);
    wrapper.append(table);
  });
})();
